import React, { useCallback, useEffect, useState } from 'react'
import { Row, Input, Col } from 'antd'
import PropTypes from 'prop-types'
// Local Files
import FiltersLayout from '../component/FiltersLayout'
import TagGroup from '../../../components/TagGroup'
import AddMore from '../component/AddMore'
import HandleInputTags from '../../../helpers/HandleInputTagsHelpers'
import isAnyField from '../helpers/isAnyField'
import { setIsOpen } from '../helpers/actionHelpers'
import FiltersCount from '../component/FiltersCount'
import { AddButton } from './styled'
import Title from 'antd/lib/typography/Title'

const Skills = ({ existedFilters, setExistedFilters }) => {
  const [values, setValues] = useState({
    skillsValue: '',
    excludeSkillsValue: '',
    skills: [],
    excludeSkills: [],
    isExcludeSkills: false,
    isOpen: false
  })

  // 🔹 Add new skill or exclude skill
  const handleAdd = useCallback(
    (activeInputValue, activeInput) => {
      if (!values[activeInputValue]) return

      const tags = HandleInputTags(activeInputValue, activeInput, values)
      if (tags.length > 0 && values[activeInputValue]) {
        const updatedValues = {
          ...values,
          [activeInput]: tags,
          [activeInputValue]: '',
          isExcludeSkills: false
        }
        setValues(updatedValues)

        const updatedSkillsFilter = {
          ...existedFilters?.skills,
          expertise: {
            ...(updatedValues.excludeSkills?.length
              ? { mustNotHave: updatedValues.excludeSkills }
              : {}),
            ...(updatedValues.skills?.length ? { shouldHave: updatedValues.skills } : {})
          }
        }

        setExistedFilters({
          ...existedFilters,
          skills: updatedSkillsFilter
        })
      }
    },
    [values, existedFilters, setExistedFilters]
  )

  // 🔹 Delete skill or excluded skill
  const handleDelete = (tags, activeTagsType) => {
    const updatedValues = { ...values, [activeTagsType]: tags }
    setValues(updatedValues)

    const updatedSkillsFilter = {
      ...existedFilters.skills,
      expertise: {
        ...(updatedValues.excludeSkills?.length
          ? { mustNotHave: updatedValues.excludeSkills }
          : {}),
        ...(updatedValues.skills?.length ? { shouldHave: updatedValues.skills } : {})
      }
    }

    setExistedFilters({
      ...existedFilters,
      skills: updatedSkillsFilter
    })
  }

  // 🔹 Clear Include Filters
  const clearIncludeFilters = () => {
    setValues({ ...values, skills: [] })
    const prev = existedFilters.skills?.expertise || {}
    const { shouldHave, ...rest } = prev
    setExistedFilters({
      ...existedFilters,
      skills: {
        ...existedFilters.skills,
        expertise: rest
      }
    })
  }

  // 🔹 Clear Exclude Filters
  const clearExcludeFilters = () => {
    setValues({ ...values, excludeSkills: [] })
    const prev = existedFilters.skills?.expertise || {}
    const { mustNotHave, ...rest } = prev
    setExistedFilters({
      ...existedFilters,
      skills: {
        ...existedFilters.skills,
        expertise: rest
      }
    })
  }

  // 🔹 Sync existed filters to local state
  useEffect(() => {
    setValues((prev) => ({
      ...prev,
      skills: existedFilters?.skills?.expertise?.shouldHave || [],
      excludeSkills: existedFilters?.skills?.expertise?.mustNotHave || []
    }))
  }, [existedFilters])

  return (
    <FiltersLayout
      title='SKILLS <span style="color: red !important">*</span>'
      activeFilters={isAnyField({ skills: values.skills })}
      clearAllFilters={clearIncludeFilters}
      setIsOpen={() => setIsOpen(setValues, values)}
      isOpen={values.isOpen}
      isSkillToolTip
    >
      {!values.skills.length && !values.isOpen && (
        <Title level={4} disabled style={{ fontSize: '14px', marginBottom: 0 }}>
          All Skills
        </Title>
      )}
      {/* Include Skills */}
      <Row
        className="filters-tags"
        style={values.skills.length ? { marginTop: '16px' } : undefined}
      >
        <TagGroup tags={values.skills} activeTagsType="skills" onDelete={handleDelete} />
      </Row>

      {values.isOpen && (
        <Row className="search-skill-row" style={{ position: 'relative' }}>
          <Input
            name="skillsValue"
            placeholder="Add Skill"
            value={values.skillsValue}
            onChange={(e) => setValues({ ...values, [e.target.name]: e.target.value })}
            onPressEnter={() => handleAdd('skillsValue', 'skills')}
          />
          <AddButton
            onClick={() => handleAdd('skillsValue', 'skills')}
            noBorder
            maxWidth
            absolute
            noBackground
            disabled={!values.skillsValue}
          >
            Add
          </AddButton>
        </Row>
      )}

      {/* Exclude Skills */}
      <Col className={values.excludeSkills.length || values.isOpen ? 'exclude-tags-area' : ''}>
        {(values.excludeSkills.length > 0 || values.isOpen) && (
          <FiltersCount
            ExcludeField={values.excludeSkills}
            clearExcludeFilters={clearExcludeFilters}
            title="Exclude Skills"
          />
        )}

        <Row className="filters-tags">
          <TagGroup
            tags={values.excludeSkills}
            isExlude={values.excludeSkills && true}
            onDelete={handleDelete}
            activeTagsType="excludeSkills"
          />
        </Row>

        {values.isExcludeSkills && values.isOpen && (
          <Row style={{ position: 'relative' }}>
            <Input
              name="excludeSkillsValue"
              placeholder="Exclude Skill"
              value={values.excludeSkillsValue}
              onChange={(e) => setValues({ ...values, [e.target.name]: e.target.value })}
              onPressEnter={(e) => handleAdd('excludeSkillsValue', 'excludeSkills')}
            />
            <AddButton
              onClick={() => handleAdd('excludeSkillsValue', 'excludeSkills')}
              noBorder
              maxWidth
              absolute
              noBackground
              disabled={!values.excludeSkillsValue}
            >
              Add
            </AddButton>
          </Row>
        )}
      </Col>

      {!values.isExcludeSkills && values.isOpen && (
        <Row
          className="excl-typo-row"
          onClick={() => setValues({ ...values, isExcludeSkills: true })}
        >
          <AddMore title="Exclude Skills" />
        </Row>
      )}
    </FiltersLayout>
  )
}

Skills.propTypes = {
  existedFilters: PropTypes.object,
  setExistedFilters: PropTypes.func
}

export default Skills
